import { render, staticRenderFns } from "./HomeFeedTripleMenuChild.vue?vue&type=template&id=154356c6&scoped=true"
import script from "./HomeFeedTripleMenuChild.vue?vue&type=script&lang=js"
export * from "./HomeFeedTripleMenuChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154356c6",
  null
  
)

export default component.exports